export default {
    calculateLevelPoints(level) {
        if (level >= 1) {
            return [this.calculateLevelUpperBound(level - 1), this.calculateLevelUpperBound(level)];
        }
    },
    calculateLevelUpperBound(level) {
        if (level >= 0) {
            const LEVEL_MULTIPLIER = 25;
            return Math.floor((LEVEL_MULTIPLIER * (1 + level) * level) / 2 );
        }
    }
};
